import styled from 'styled-components'
import { Button, Card, Form, Modal, Table, Tabs } from 'antd'
import CardContent from '@material-ui/core/CardContent'
import CheckIcon from '@material-ui/icons/Check'

export const Centered = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`

export const Text = styled.span`
  font-size: 16px;
  color: #000;

  ${(props) => props.bold && `font-weight: bold;`}
  ${(props) => props.cursor && `cursor: ${props.cursor};`}
  ${(props) => props.size && `font-size: ${props.size}px;`}
  ${(props) => props.color && `color: ${props.color};`}
  
  @media (min-width: 320px) and (orientation: portrait) {
    font-size: 14px !important;
  }

  @media (min-width: 375px) and (max-height: 667px) and (orientation: portrait) {
    font-size: 14px !important;
  }

  @media (min-width: 414px) and (max-height: 736px) and (orientation: portrait) {
    font-size: 14px !important;
  }

  @media (min-width: 375px) and (max-width: 812px) and (orientation: portrait) {
    font-size: 14px !important;
  }
`

export const MainStep4Div = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  height: 100vh;
`

export const CheckIconDiv = styled.div`
  background-color: #6ebf4b;
  border-radius: 50%;
  width: 100px;
  height: 100px;
`

export const CheckIconEx = styled(CheckIcon)`
  font-size: 95px !important;
  color: white !important;
`

export const DetailSelectionModal = styled(Modal)`
  .ant-modal-header {
    background-color: #6ebf4b !important;

    .ant-modal-title {
      color: white !important;
    }
  }

  .ant-modal-body {
    padding: 12px 0 !important;
  }
`

export const ButtonEx = styled(Button)`
  &:hover {
    ${(props) =>
      props.color &&
      `
      background-color: ${props.color};
      border-color: ${props.color};
    `}
  }

  ${(props) =>
    props.color &&
    `
      background-color: ${props.color};
      border-color: ${props.color};
    `}
`

export const CardEx = styled(Card)``

export const CardQrEx = styled(Card)`
  .ant-card-head {
    background: #6ebf4b;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    padding: 0 !important;
  }

  div > .ant-card-bordered {
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
  }
`

export const Container = styled(CardContent)`
  padding: 0 5%;
  margin-left: auto;
  margin-right: auto;

  @media only screen and (min-device-width: 320px) and (max-device-width: 480px) and (orientation: portrait) {
    width: 100% !important;
    height: auto !important;
  }

  @media only screen and (min-device-width: 320px) and (max-device-width: 568px) and (orientation: portrait) {
    width: 100% !important;
    height: auto !important;
  }

  @media only screen and (min-device-width: 375px) and (max-device-width: 667px) and (orientation: portrait) {
    width: 100% !important;
    height: auto !important;
  }

  @media only screen and (min-device-width: 414px) and (max-device-width: 736px) and (orientation: portrait) {
    width: 100% !important;
    height: auto !important;
  }

  @media only screen and (min-device-width: 375px) and (max-device-width: 812px) and (orientation: portrait) {
    width: 100% !important;
    height: auto !important;
  }
`

export const FormItem = styled(Form.Item)`
  .ant-form-item-control-input-content {
    -ms-flex: auto;
    flex: auto;
    max-width: 100%;
    display: flex !important;
    flex-direction: row !important;
    justify-content: center !important;
  }
`

export const ButtonSolid = styled.div`
  height: 40px;
  border: 1px solid #e3e7ed;
  cursor: pointer;
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  margin: 2px;
  border-radius: 10px;
  padding: 10px;
  font-size: 12px;

  ${(props) =>
    props.active &&
    `
            background: #6ebf4b;
            border-color: #6ebf4b;
            color: #fff;
    `}
`

export const CardContentEx = styled(CardContent)`
  width: inherit;

  ${(props) => props.width && `width: ${props.width}px !important;`}

  @media only screen and (min-device-width: 320px) and (max-device-width: 480px) and (orientation: portrait) {
    width: 100% !important;
    height: auto !important;
  }

  @media only screen and (min-device-width: 320px) and (max-device-width: 568px) and (orientation: portrait) {
    width: 100% !important;
    height: auto !important;
  }

  @media only screen and (min-device-width: 375px) and (max-device-width: 667px) and (orientation: portrait) {
    width: 100% !important;
    height: auto !important;
  }

  @media only screen and (min-device-width: 414px) and (max-device-width: 736px) and (orientation: portrait) {
    width: 100% !important;
    height: auto !important;
  }

  @media only screen and (min-device-width: 375px) and (max-device-width: 812px) and (orientation: portrait) {
    width: 100% !important;
    height: auto !important;
  }
`

export const SelectItem = styled.div`
  height: 40px;
  border: 1px solid #e3e7ed;
  cursor: pointer;
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  margin: 2px;
  border-radius: 10px;
  padding: 10px;
  font-size: 12px;

  ${(props) =>
    props.active &&
    `
            background: #6ebf4b;
            border-color: #6ebf4b;
            color: #fff;
    `}
`

export const MaterialItem = styled.li`
  height: 30px;
  border: 1px solid #e3e7ed;
  cursor: pointer;
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  margin: 2px;
  border-radius: 10px;
  padding: 10px;

  ${(props) =>
    props.active &&
    `
            background: #6ebf4b;
            border-color: #6ebf4b;
            color: #fff;
    `}
`

export const TypeItem = styled.div`
  height: 40px;
  border: 1px solid #e3e7ed;
  cursor: pointer;
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  margin: 2px;
  border-radius: 10px;
  padding: 10px;

  ${(props) =>
    props.active &&
    `
            background: #6ebf4b;
            border-color: #6ebf4b;
            color: #fff;
    `}
`

export const TableEx = styled(Table)`
  .ant-table-thead > tr > .ant-table-cell {
    background-color: #6ebf4b;
    color: white;
  }
`

export const TabsEx = styled(Tabs)`
  .ant-tabs-tab.ant-tabs-tab-active {
    background-color: #6ebf4b !important;
    color: white !important;

    .ant-tabs-tab-btn {
      color: white !important;
    }
  }
`

export const AnnouncementItem = styled.div`
  padding: 1rem;
  border: 1px solid #6ebf4b;
  width: 100%;
  border-radius: 10px;
  cursor: pointer;
`

export const TagItem = styled.div`
  background-color: #6ebf4b;
  color: white;
  cursor: pointer;
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  border-radius: 10px;
  padding: 5px;
`

export const ColumnCenter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`

export const MenuContainer = styled.div``

export const MenuItem = styled.div`
  border: 2px solid #6cbe4c;
  border-radius: 25px;
  width: 190px;
  height: 190px;
  cursor: pointer;
  padding: 1rem;

  @media only screen and (min-device-width: 320px) and (max-device-width: 480px) and (orientation: portrait) {
    width: 150px;
    height: 150px;
  }

  @media only screen and (min-device-width: 320px) and (max-device-width: 568px) and (orientation: portrait) {
    width: 150px;
    height: 150px;
  }

  @media only screen and (min-device-width: 375px) and (max-device-width: 667px) and (orientation: portrait) {
    width: 150px;
    height: 150px;
  }

  @media only screen and (min-device-width: 414px) and (max-device-width: 736px) and (orientation: portrait) {
    width: 150px;
    height: 150px;
  }

  @media only screen and (min-device-width: 375px) and (max-device-width: 812px) and (orientation: portrait) {
    width: 150px;
    height: 150px;
  }
`

export const MenuText = styled.span`
  font-size: 18px;
  font-weight: normal;
  color: #7fb52a;
`

export const Image = styled.img`
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
`



// WEBPACK FOOTER //
// ./src/shared.style.js